import React, { useCallback, useEffect, useState } from 'react';
import * as CryptoJS from "crypto-js";
import { getBlockList, getSavedITDepBlockWise, getFinancialYearList } from "../../services/it-depreciation.service";

// Helper to format date for Table Headers
function getFormatedDate(dateString) {
    if (dateString != null && dateString !== '') {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return day + '-' + month + '-' + year;
    }
    return 'NA';
}

const formatDateForServer = (dateString) => {
    if (!dateString) return null;
    const d = new Date(dateString);
    const year = d.getFullYear();
    const month = (`0${d.getMonth() + 1}`).slice(-2);
    const day = (`0${d.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
};

function OBITLog() {
    const [blocks, setBlocks] = useState([]);
    const [financialYears, setFinancialYears] = useState([]);
    const [fyId, setFYId] = useState('');

    const [earliestPeriodtDate, setEearliestPeriodtDate] = useState('');
    const [closingPeriodDate, setClosingPeriodDate] = useState('');

    const [success, setSuccess] = useState('');
    const [errMsg, setErrMsg] = useState('');

    const fetchInitialData = useCallback(async () => {
        try {
            const token = sessionStorage.getItem('LoggedInToken');
            const companyId = sessionStorage.getItem('LoggedInCompanyId');
            const secretKey = process.env.REACT_APP_ENCRYPT_SECRET_KEY;

            const commonPayload = CryptoJS.AES.encrypt(
                JSON.stringify({ authToken: token, company_id: companyId }),
                secretKey
            ).toString();

            const blockRes = await getBlockList({ token: commonPayload });
            if (blockRes?.data?.data?.length) {
                const initialData = blockRes.data.data.map(block => ({
                    id: block.id,
                    block_name: block.block_name,
                    block_rate: block.block_rate,
                    opening_wdv: 0, sale_proceeds: 0, add_more_180: 0, add_less_180: 0,
                    total_value: 0, dep_opening: 0, more_then_6_month: 0, less_then_6_month: 0,
                    esd_dep: 0, total_depreciation: 0, net_wdv: 0
                }));
                setBlocks(initialData);
            }

            const fyRes = await getFinancialYearList({ token: commonPayload });
            if (fyRes?.data?.data?.length) {
                setFinancialYears(fyRes.data.data);
            }
        } catch (err) {
            console.error("Error fetching initial data:", err);
        }
    }, []);

    const getFilledData = useCallback(async (startDate, endDate) => {
        try {
            const token = sessionStorage.getItem('LoggedInToken');
            const payload = { earliest_period: formatDateForServer(startDate), closing_period: formatDateForServer(endDate) };

            const EncryptData = CryptoJS.AES.encrypt(
                JSON.stringify({ param_data: payload, authToken: token }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();

            const res = await getSavedITDepBlockWise({ token: EncryptData });

            if (res?.data?.data && Array.isArray(res.data.data) && res.data.data.length > 0) {
                const dbRowsArray = res.data.data;
                setBlocks(prevBlocks => prevBlocks.map(masterBlock => {
                    const savedRow = dbRowsArray.find(r => parseInt(r.block_id) === parseInt(masterBlock.id));
                    return savedRow ? {
                        ...masterBlock,
                        opening_wdv: parseFloat(savedRow.opening_wdv) || 0,
                        sale_proceeds: parseFloat(savedRow.sale_proceeds) || 0,
                        add_more_180: parseFloat(savedRow.add_more_180) || 0,
                        add_less_180: parseFloat(savedRow.add_less_180) || 0,
                        total_value: parseFloat(savedRow.total_value) || 0,
                        dep_opening: parseFloat(savedRow.dep_opening) || 0,
                        more_then_6_month: parseFloat(savedRow.more_then_6_month) || 0,
                        less_then_6_month: parseFloat(savedRow.less_then_6_month) || 0,
                        esd_dep: parseFloat(savedRow.esd_dep) || 0,
                        total_depreciation: parseFloat(savedRow.total_depreciation) || 0,
                        net_wdv: parseFloat(savedRow.net_wdv) || 0
                    } : { ...masterBlock, opening_wdv: 0, sale_proceeds: 0, add_more_180: 0, add_less_180: 0, total_value: 0, dep_opening: 0, more_then_6_month: 0, less_then_6_month: 0, esd_dep: 0, total_depreciation: 0, net_wdv: 0 };
                }));
                setSuccess("Data loaded successfully");
                setErrMsg("");
            } else {
                setBlocks(prev => prev.map(b => ({ ...b, opening_wdv: 0, sale_proceeds: 0, add_more_180: 0, add_less_180: 0, total_value: 0, dep_opening: 0, more_then_6_month: 0, less_then_6_month: 0, esd_dep: 0, total_depreciation: 0, net_wdv: 0 })));
                setSuccess("");
                setErrMsg("No records found for this year.");
            }
        } catch (err) {
            setErrMsg("Error loading data.");
        }
    }, []);

    useEffect(() => {
        fetchInitialData();
    }, [fetchInitialData]);

    const handleFinYearChange = (e) => {
        const selectedId = e.target.value;
        setFYId(selectedId);

        const selectedObj = financialYears.find(fy => fy.id.toString() === selectedId.toString());
        if (selectedObj) {
            setEearliestPeriodtDate(selectedObj.start_date);
            setClosingPeriodDate(selectedObj.end_date);
            getFilledData(selectedObj.start_date, selectedObj.end_date);
        } else {
            setEearliestPeriodtDate('');
            setClosingPeriodDate('');
            setBlocks(prev => prev.map(b => ({ ...b, opening_wdv: 0, sale_proceeds: 0, add_more_180: 0, add_less_180: 0, total_value: 0, dep_opening: 0, more_then_6_month: 0, less_then_6_month: 0, esd_dep: 0, total_depreciation: 0, net_wdv: 0 })));
        }
    };

    const calculateGrandTotal = (fieldName) => {
        const total = blocks.reduce((sum, block) => sum + (parseFloat(block[fieldName]) || 0), 0);
        return total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    return (
        <div className="container-fluid mt-4">
            <div className="card shadow mb-4">
                <div className="card-header py-3 bg-light border-bottom">
                    <h5 className="m-0 font-weight-bold text-primary text-uppercase" style={{letterSpacing: '1px'}}>
                        IT OB Log
                    </h5>
                </div>

                <div className="card-body">

                    <div className="col-md-8 pt-3">
                        {success && <span className="alert alert-success py-2 px-3 small fw-bold shadow-sm">{success}</span>}
                        {errMsg && <span className="alert alert-danger py-2 px-3 small fw-bold shadow-sm">{errMsg}</span>}
                    </div>


                    <div className="row mb-4">
                        <div className="col-3">
                            <label>Select Financial Year <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-3">
                            <select className="form-select" value={fyId} onChange={handleFinYearChange}>
                                <option value="">Select Financial Year</option>
                                {financialYears.map((fy) => (
                                    <option key={fy.id} value={fy.id}>{fy.financialYearName}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* SCROLLER WRAPPER START */}
                    <div className="table-responsive shadow-sm rounded border" style={{ overflowX: 'auto', backgroundColor: '#fff' }}>
                        <table className="table table-bordered table-hover align-middle mb-0"
                                   style={{ fontSize: '12px', minWidth: '1600px' }}>

                            <thead className="text-center align-middle bg-dark text-white shadow-sm" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                            <tr style={{whiteSpace: 'nowrap'}}>
                                {/* 1. TAG Header (Left: 0) */}
                                <th rowSpan={2} style={{ minWidth: '150px', position: 'sticky', left: 0, zIndex: 11 }}>TAG</th>

                                {/* 2. Income Tax Block Header (Left: 100px) */}
                                <th rowSpan={2} style={{ minWidth: '350px', position: 'sticky', left: '100px', zIndex: 11 }}>Income Tax Block</th>

                                {/* 3. Block Rate Header (Left: 100px + 350px = 450px) */}
                                <th rowSpan={2} style={{ minWidth: '100px', position: 'sticky', left: '450px', zIndex: 11 }}>Block Rate</th>

                                <th rowSpan={2} style={{ minWidth: '130px' }}>Opening WDV<br/><small className="text-warning">({earliestPeriodtDate ? getFormatedDate(earliestPeriodtDate) : 'NA'})</small></th>
                                <th rowSpan={2} style={{ minWidth: '130px' }}>Sale Proceeds</th>
                                <th colSpan={2} className="bg-info">Additions</th>
                                <th rowSpan={2} style={{ minWidth: '130px' }}>Total Value</th>
                                <th colSpan={5} className="bg-info">Depreciation</th>
                                <th rowSpan={2} style={{ minWidth: '130px' }}>Net WDV<br/><small className="text-warning">({closingPeriodDate ? getFormatedDate(closingPeriodDate) : 'NA'})</small></th>
                            </tr>
                            <tr style={{whiteSpace: 'nowrap', backgroundColor: '#34495e'}}>
                                <th style={{ minWidth: '110px' }}>&gt; 180 Days</th>
                                <th style={{ minWidth: '110px' }}>&lt; 180 Days</th>
                                <th style={{ minWidth: '110px' }}>Opening</th>
                                <th style={{ minWidth: '110px' }}>&gt; 6 Months</th>
                                <th style={{ minWidth: '110px' }}>&lt; 6 Months</th>
                                <th style={{ minWidth: '110px' }}>ESD Dep.</th>
                                <th style={{ minWidth: '110px' }}>Total Dep.</th>
                            </tr>
                            </thead>

                            <tbody className="bg-white">
                            {blocks.map((block, index) => (
                                <tr key={index} className="text-end">
                                    {/* 1. TAG Cell Freeze */}
                                    <td className="text-start fw-bold text-dark"
                                        style={{ position: 'sticky', left: 0, backgroundColor: '#fdfefe', zIndex: 1, borderRight: '1px solid #dee2e6' }}>
                                        {block.tag_name || 'N/A'}
                                    </td>

                                    {/* 2. Income Tax Block Cell Freeze (left: 100px) */}
                                    <td className="text-start fw-bold text-dark"
                                        style={{ position: 'sticky', left: '100px', backgroundColor: '#fdfefe', zIndex: 1, borderRight: '1px solid #dee2e6' }}>
                                        {block.block_name}
                                    </td>

                                    {/* 3. Block Rate Cell Freeze (left: 450px) */}
                                    <td className="text-center bg-light"
                                        style={{ position: 'sticky', left: '450px', zIndex: 1, borderRight: '2px solid #dee2e6' }}>
                                        {block.block_rate}%
                                    </td>

                                    <td>{block.opening_wdv.toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                                    <td>{block.sale_proceeds.toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                                    <td>{block.add_more_180.toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                                    <td>{block.add_less_180.toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                                    <td className="fw-bold text-primary bg-light">{block.total_value.toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                                    <td>{block.dep_opening.toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                                    <td>{block.more_then_6_month.toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                                    <td>{block.less_then_6_month.toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                                    <td>{block.esd_dep.toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                                    <td className="fw-bold text-danger bg-light">{block.total_depreciation.toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                                    <td className="fw-bold text-success" style={{backgroundColor: '#e9f7ef'}}>{block.net_wdv.toLocaleString(undefined, {minimumFractionDigits: 2})}</td>
                                </tr>
                            ))}
                            </tbody>

                            <tfoot className="bg-light font-weight-bold text-end border-top-2" style={{ position: 'sticky', bottom: 0, zIndex: 5 }}>
                            <tr style={{fontSize: '13px'}}>
                                {/* Grand Total Label cells freeze */}
                                <td className="text-center text-uppercase p-3 bg-light"
                                    style={{ position: 'sticky', left: 0, zIndex: 6, fontWeight: 'bold' }}>Grand Total:</td>
                                <td className="bg-light" style={{ position: 'sticky', left: '100px', zIndex: 6 }}>-</td>
                                <td className="bg-light" style={{ position: 'sticky', left: '450px', zIndex: 6 }}>-</td>

                                <td className="text-primary">{calculateGrandTotal('opening_wdv')}</td>
                                <td>{calculateGrandTotal('sale_proceeds')}</td>
                                <td>{calculateGrandTotal('add_more_180')}</td>
                                <td>{calculateGrandTotal('add_less_180')}</td>
                                <td className="text-primary bg-white">{calculateGrandTotal('total_value')}</td>
                                <td>{calculateGrandTotal('dep_opening')}</td>
                                <td>{calculateGrandTotal('more_then_6_month')}</td>
                                <td>{calculateGrandTotal('less_then_6_month')}</td>
                                <td>{calculateGrandTotal('esd_dep')}</td>
                                <td className="text-danger bg-white">{calculateGrandTotal('total_depreciation')}</td>
                                <td className="text-success bg-white">{calculateGrandTotal('net_wdv')}</td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    {/* SCROLLER WRAPPER END */}

                </div>
            </div>
        </div>
    );
}

export default OBITLog;